import MetaModel from "../../../Global/Models/Pagination/MetaModel";
import StandingGamePredictionModel from "./Prediction/StandingGamePredictionModel";

export default class StandingGamePredictionsModel {
  public meta: MetaModel = new MetaModel();
  public data: StandingGamePredictionModel[] = [];
}
